import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { "data-qa": "like-action:LikesCount" }
const _hoisted_2 = { "data-qa": "like-action:LikesCount" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(['gfu-like', {'is-liked': $props.isLiked}])
  }, [
    ($props.enabled)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "",
          class: "gfu-link gfu-link--nofx",
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('like')), ["prevent"])),
          "data-qa": "like-action:Like"
        }, [
          _createVNode(_component_base_icon, { name: "thumbs-up" }),
          _createElementVNode("span", _hoisted_1, _toDisplayString($props.likesCount), 1 /* TEXT */)
        ]))
      : (_openBlock(), _createBlock(_component_tooltip, {
          key: 1,
          text: $options.tooltipText,
          "data-qa": "like-action:Tooltip"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_base_icon, {
              name: "thumbs-up",
              "data-qa": "like-action:Like"
            }),
            _createElementVNode("span", _hoisted_2, _toDisplayString($props.likesCount), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["text"]))
  ], 2 /* CLASS */))
}